import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import { useInstance } from 'intact-vue-next';
import { isEqualArray } from '../utils';
export function useFilterable(keywords, setValue, getField, values) {
  var instance = useInstance();
  function filter() {
    var ret = [];
    var _instance$get = instance.get(),
      data = _instance$get.data,
      filter = _filterInstanceProperty(_instance$get);
    if (!filter) {
      filter = function filter(keywords, data) {
        var _context;
        return _includesInstanceProperty(_context = getField(data, 'label')).call(_context, keywords);
      };
    }
    var loop = function loop(data, prefix, valid, disabled) {
      if (prefix === void 0) {
        prefix = [];
      }
      if (valid === void 0) {
        valid = false;
      }
      if (disabled === void 0) {
        disabled = false;
      }
      data.forEach(function (item) {
        var _valid = valid || filter(keywords.value, item);
        var _disabled = disabled || getField(item, 'disabled');
        var _prefix = _sliceInstanceProperty(prefix).call(prefix, 0);
        _prefix.push(item);
        var children = getField(item, 'children');
        if (children) {
          loop(children, _prefix, _valid, _disabled);
        } else if (_valid) {
          _prefix.disabled = _disabled;
          ret.push(_prefix);
        }
      });
    };
    loop(data);
    return ret;
  }
  function selectByFilter(data) {
    setValue(getValue(data));
  }
  function isSelectedItem(data) {
    var _context2;
    return !!_findInstanceProperty(_context2 = values.value).call(_context2, function (value) {
      return isEqualArray(value, getValue(data));
    });
  }
  function getValue(data) {
    return _mapInstanceProperty(data).call(data, function (item) {
      return getField(item, 'value');
    });
  }
  return {
    filter: filter,
    selectByFilter: selectByFilter,
    keywords: keywords,
    isSelectedItem: isSelectedItem
  };
}